module.exports = __webpack_public_path__ + "static/img/079_TO8_1721.f02bc52.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/079_TO8_1721.jpg
// module id = x9US
// module chunks = 0